import React, { Suspense } from 'react';

import RootModal from 'src/components/modals';
import Notifications from './Notifications';
import { Box, CircularProgress } from '@material-ui/core';

require('./less/App.less');

const LoadingApp = () => (
  <Box
    display={'flex'}
    justifyContent='center'
    alignItems='center'
    height='100vh'
  >
    <CircularProgress size={50} className='app-loading' />
  </Box>
);

const App: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<LoadingApp />}>
    {children}
    <Notifications />
    <RootModal />
  </Suspense>
);

export default App;
